import { render, staticRenderFns } from "./MobileMenuContacts.vue?vue&type=template&id=36e00436&scoped=true&"
import script from "./MobileMenuContacts.vue?vue&type=script&lang=js&"
export * from "./MobileMenuContacts.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuContacts.vue?vue&type=style&index=0&id=36e00436&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e00436",
  null
  
)

export default component.exports